import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
	Row,
	Col,
	Container,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Button,
	UncontrolledDropdown
} from 'reactstrap';

import Page from '../../components/Layout/Page/Page';
import TrackWave from '../../components/Tracks/TrackWave/TrackWave';
import TopWeeklyDiscoveryCard from '../../components/Cards/TopWeeklyDiscoveryCard/TopWeeklyDiscoveryCard';
import PlayButton from '../../components/Buttons/PlayButton/PlayButton';
import Loader from '../../components/Common/Loader';
import RoundedButton from '../../components/Buttons/RoundedButton/RoundedButton';

import { ReactComponent as FacebookIcon } from '../../assets/images/fb.svg';
import { ReactComponent as InstagramIcon } from '../../assets/images/ig.svg';
import { ReactComponent as TwitterIcon } from '../../assets/images/tw.svg';
import { ReactComponent as WebsiteIcon } from '../../assets/images/web.svg';
import { ReactComponent as ExpandIcon } from '../../assets/images/expand.svg';
import { ReactComponent as RewardsIcon } from '../../assets/images/reward.svg';

import { loadAllTracks, loadTrackComments } from '../../helpers/api/tracks.api';
import { loadUserStats } from '../../helpers/api/users.api';

import './Dashboard.scss';

const Dashboard = (props) => {
	const [loading, setLoading] = useState(true);
	const [loadingStats, setLoadingStats] = useState(true);

	const [playing, setPlaying] = useState(false);

	const [tracks, setTracks] = useState(null);
	const [selectedTrack, setSelectedTrack] = useState(null);
	const [trackComments, setTrackComments] = useState([]);

	const [stats, setStats] = useState(null);

	useEffect(() => {
		setLoadingStats(true);
		loadUserStats()
			.then((result) => {
				if (result.success) setStats(result.stats);
				else {
					console.log(result.message);
					setStats(null);
				}
				setLoadingStats(false);
			})
			.catch((error) => {
				setStats(null);
				setLoadingStats(false);
				console.log(error);
			});
	}, []);

	useEffect(() => {
		if (props.user && props.user.type === 'artist') {
			setLoading(true);
			loadAllTracks()
				.then((result) => {
					if (result.success) {
						setTracks(result.tracks);
						setSelectedTrack(result.tracks[0]);
					} else {
						console.log(result.message);
						setTracks([]);
						setSelectedTrack(null);
					}
					setLoading(false);
				})
				.catch((error) => {
					setTracks([]);
					setSelectedTrack(null);
					setLoading(false);
					console.log(error);
				});
		}
	}, [props.user]);

	useEffect(() => {
		if (tracks && tracks[0]) setSelectedTrack(tracks[0]);
		else setSelectedTrack(null);
	}, [tracks]);

	useEffect(() => {
		if (selectedTrack) loadComments();
	}, [selectedTrack]);

	function loadComments() {
		loadTrackComments(selectedTrack._id)
			.then((result) => {
				if (result.success) {
					setTrackComments(result.comments);
				} else {
					console.log(result.message);
					setTrackComments([]);
				}
			})
			.catch((error) => {
				setTrackComments([]);
				console.log(error);
			});
	}

	const links = [];
	if (props.user) {
		if (props.user.websiteUrl)
			links.push(
				<Link className="social-link" target="_blank" to={props.user.websiteUrl}>
					<WebsiteIcon />
				</Link>
			);
		if (props.user.facebookUrl)
			links.push(
				<Link className="social-link" target="_blank" to={props.user.facebookUrl}>
					<FacebookIcon />
				</Link>
			);
		if (props.user.instagramUrl)
			links.push(
				<Link className="social-link" target="_blank" to={props.user.instagramUrl}>
					<InstagramIcon />
				</Link>
			);
		if (props.user.twitterUrl)
			links.push(
				<Link className="social-link" target="_blank" to={props.user.twitterUrl}>
					<TwitterIcon />
				</Link>
			);
	}

	return <Page className="dashboard"> {props.user && (
		<Container fluid>
			<Row className="pb-lg-5">
				<Col className="d-flex flex-column justify-content-between" md="8">
					{props.user.type === 'scout' &&
						(loadingStats ? (
							<Loader className="h-100 w-100" />
						) : stats ? (
							<>
								<h3 className="mb-0">Statistiche</h3>
								<Row className="h-100 pt-3">
									<Col xs="6" lg="6">
										<div className="stats h-100 mb-5">
											<span className="mt-5">
												{stats.tracksToEvaluate}
											</span>
											<span>
												Brani
												<br />
												da valutare
											</span>
											<RoundedButton
												color="primary"
												onClick={() => {
													props.history.push('/tracks');
												}}>
												VAI AI BRANI
											</RoundedButton>
										</div>
									</Col>
									<Col xs="6" lg="6">
										<div className="stats mb-5">
											<span className="mt-5">
												{stats.savedTracks}
											</span>
											<span>
												Brani
												<br />
												salvati
											</span>
											<RoundedButton
												color="primary"
												onClick={() => {
													props.history.push('/playlists');
												}}>
												VEDI PLAYLIST
											</RoundedButton>
										</div>
									</Col>
									<Col xs="6" lg="6">
										<div className="stats mb-5">
											<span className="mt-5">
												{Number(stats.walletValue / 100).toFixed(2) + '€'}
											</span>
											<span>accumulati</span>
											<RoundedButton
												color="primary"
												onClick={() => {
													props.history.push('/wallet');
												}}>
												PAGAMENTI
											</RoundedButton>
										</div>
									</Col>
								</Row>
							</>
						) : null)}
					{props.user.type === 'artist' &&
						(loading ? (
							<Loader />
						) : selectedTrack ? (
							<>
								<Row className="mb-5">
									<Col lg="7">
										<div className="h-100 d-flex align-items-center">
											<div className="d-flex flex-column mr-5">
												<h6>
													<i>I tuoi brani</i>
												</h6>
												<UncontrolledDropdown>
													<DropdownToggle>
														<h4>{selectedTrack.title}</h4>
														<Button
															color="link"
															className="expand-button d-inline">
															<ExpandIcon />
														</Button>
													</DropdownToggle>
													<DropdownMenu>
														{tracks
															.filter(
																(t) =>
																	t._id !==
																	selectedTrack._id
															)
															.map((t) => (
																<DropdownItem
																	key={t._id}
																	onClick={() =>
																		setSelectedTrack(t)
																	}>
																	{t.title}
																</DropdownItem>
															))}
													</DropdownMenu>
												</UncontrolledDropdown>
											</div>
											<PlayButton
												playing={playing}
												onClick={() => setPlaying(!playing)}
											/>
										</div>
									</Col>
									<Col className="d-none d-lg-block" lg="5">
										<div className="h-100 d-flex justify-content-end align-items-center">
											<p className="track-points">
												{selectedTrack.points || 0}
												{' punti'}
											</p>
											<p className="track-rewards">
												<RewardsIcon />
												{selectedTrack.rewards
													? selectedTrack.rewards.length
													: 0}
												{' Rewards'}
											</p>
										</div>
									</Col>
								</Row>
								<Row>
									<Col>
										<div className="wave-wrapper">
											<TrackWave
												audioFile={selectedTrack.file.url}
												playing={playing}
												comments={trackComments}
											/>
										</div>
									</Col>
								</Row>
							</>
						) : null)}
				</Col>
				<Col md="4" className="d-none d-lg-block">
					<TopWeeklyDiscoveryCard className="mb-4 mb-lg-0"/>
				</Col>
			</Row>
			{props.user.type === 'artist'
				? stats && (
					<Row className="pt-lg-5 mb-5">
						<Col>
							<h3 className="mb-3 mb-lg-5">Statistiche</h3>
							{loadingStats ? (
								<Loader />
							) : (
								<Row className="py-3 py-lg-5">
									<Col
										className="h-100 d-flex align-items-center justify-content-center"
										xs="4">
										<div className="stats">
											<span>{stats.averageScore || 0}</span>
											<span>Punti</span>
										</div>
									</Col>
									<Col
										className="h-100 d-flex align-items-center justify-content-center"
										xs="4">
										<div className="stats">
											<span>{stats.feedbacksCount || 0}</span>
											<span>Feedback</span>
										</div>
									</Col>
									<Col
										className="h-100 d-flex align-items-center justify-content-center"
										xs="4">
										<div className="stats">
											<span>{stats.rewardsCount || 0}</span>
											<span>Rewards</span>
										</div>
									</Col>
								</Row>
							)}
						</Col>
						{/* MESSAGGES CARD */}
						{/* <Col className="h-100" md="4">
                    <Card className="h-100">
                        <CardHeader></CardHeader>
                        <CardBody></CardBody>
                    </Card>
                </Col> */}
					</Row>
				)
				: null}

			<Row>
				<Col className="d-block d-lg-none">
					<TopWeeklyDiscoveryCard  className="mb-4 mb-lg-0" />
				</Col>
			</Row>
		</Container>
	)}</Page>;
};

const mapStateToProps = (state) => {
	return {
		user: state.Auth.user
	};
};

export default connect(mapStateToProps, null)(Dashboard);
